export class SignoutModel{
    public token : string;
}